import React, { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "./routes";

export const AuthRoute = memo(({ token }: { token: boolean }) => {
  return !token ? <Outlet /> : <Navigate to={ROUTES.DASHBOARD} replace/>
});
